<script setup>
import { ref, computed, watch } from 'vue';
import BaseInputFloatingLabel from "@/components/forms/BaseInputFloatingLabel.vue";

const props = defineProps({
  config: Object,
  modelValue: [String, Number],
  allowNegative: {
    type: Boolean,
    default: false
  }
});

const defaultConfig = computed(() => {
  const regex = props.allowNegative
    ? /[^0-9.-]|(?!^)-|(?<=\..*)\./g // Allow '-' at the start if allowNegative is true
    : /[^0-9.]|(?<=\..*)\./g;       // Disallow '-' if allowNegative is false

  return {
    allowedCharacters: regex,
  };
});
const mergedConfig = computed(() => ({
  ...defaultConfig.value,
  ...props.config
}));

const emits = defineEmits(['update:modelValue']);

const inputValue = ref(String(props.modelValue));

watch(() => props.modelValue, (newValue) => {
  inputValue.value = String(newValue);
});

watch(inputValue, (newValue) => {
  emits('update:modelValue', newValue);
});
</script>

<template>
  <BaseInputFloatingLabel
    :config="mergedConfig"
    v-model="inputValue"
  />
</template>
